import R from 'ramda'
import { fromNullable } from 'data.maybe'

export default ({
  getData = state =>
    Array.isArray(state.data) ? state.data : state.data.filteredData,
  getHeaders = state => state.headers,
  getSelection = state => state.selection,
  getHeaderMap = state => state.headerMap,
  getDataAtRow = (rowIndex, state) => getData(state)[rowIndex - 1],
  getKeyAtCol = (colIndex, state) => getHeaders(state)[colIndex],
  getEditContent = state => state.editContent,
  getEditPosition = state => state.editPosition,
  isEditing = R.compose(d => !R.isNil(d), getEditPosition),
  getCellData = (rowIndex, columnIndex, state) => {
    const headerKey = getKeyAtCol(columnIndex, state)
    const headerMap = getHeaderMap(state)
    return rowIndex === 0
      ? headerMap[headerKey]
      : getDataAtRow(rowIndex, state)[headerKey]
  },
  getDataCount = R.compose(data => data.length + 1, getData),
  getColCount = R.compose(headers => headers.length, getHeaders),
  isSelectingCells = state => state.selecting,
  getSelectedBounds = state => {
    const selection = getSelection(state)
    if (R.isNil(selection) || R.isEmpty(selection)) return {}

    const { x1, y1, x2, y2 } = selection

    const xMin = !R.isNil(x2) ? Math.min(x1, x2) : x1
    const xMax = !R.isNil(x2) ? Math.max(x1, x2) : x1
    const yMin = !R.isNil(y2) ? Math.min(y1, y2) : y1
    const yMax = !R.isNil(y2) ? Math.max(y1, y2) : y1
    return { x1: xMin, x2: xMax, y1: yMin, y2: yMax }
  },
  isCellSelected = (rowIndex, columnIndex, state) => {
    const { x1, y1, x2, y2 } = getSelectedBounds(state)
    return (
      rowIndex >= y1 && rowIndex <= y2 && columnIndex >= x1 && columnIndex <= x2
    )
  },
  createGetSelectedData = cellDataGetter => state => {
    const bounds = getSelectedBounds(state)
    if (R.isNil(bounds) || R.isEmpty(bounds)) return []
    const { x1, x2, y1, y2 } = bounds

    return R.range(y1, y2 + 1).map(row =>
      R.range(x1, x2 + 1).map(col => cellDataGetter(row, col, state))
    )
  },
  // Array[Array]
  getSelectedData = createGetSelectedData(getCellData),
  getSelectedRows = state => {
    const bounds = getSelectedBounds(state)
    if (R.isNil(bounds) || R.isEmpty(bounds)) return []
    const { y1, y2 } = bounds
    return R.range(y1, y2 + 1).map(r => getDataAtRow(r, state))
  },

  isCellEditing = (rowIndex, columnIndex, state) =>
    fromNullable(getEditPosition(state))
      .map(pos => rowIndex === pos.rowIndex && columnIndex === pos.columnIndex)
      .getOrElse(false),

  isContextMenuVisible = state => state.contextMenuVisible,
  getEditInitKey = state => state.editInitKey,
}) => ({
  getData,
  getHeaders,
  getSelection,
  getHeaderMap,
  getDataAtRow,
  getKeyAtCol,
  getEditContent,
  getEditPosition,
  isEditing,
  getCellData,
  getDataCount,
  getColCount,
  isSelectingCells,
  getSelectedBounds,
  isCellSelected,
  createGetSelectedData,
  getSelectedData,
  isCellEditing,
  isContextMenuVisible,
  getEditInitKey,
  getSelectedRows,
})
